<template>
  <div>
    <i v-if="record.status === 'failed'" class="fas fa-ellipsis-v disabled"></i>
    <ActionsMenu
      v-else
      :actions="actions"
      :options="{
        theme: 'light tooltip-standard-size'
      }"
      @view-payment-details="togglePaymentsDetailsModal(true)"
      @dispute-charge="toggleVoidConfirmation('dispute')"
      @remove-payment="toggleVoidConfirmation('remove')"
    />
    <ActionConfirmationModal
      v-if="voidModal"
      :modal-contents="modalContents"
      @hide-modal="toggleVoidConfirmation"
    />
    <PaymentsDetailsModal
      v-if="showPaymentDetailsModal"
      :record="record"
      @hide-modal="togglePaymentsDetailsModal"
    />
  </div>
</template>

<script>
import ActionsMenu from "@/components/ActionsMenu.vue";
import RemovePaymentIcon from "@/images/remove_payment_icon.svg?component";
import PaymentsDetailsModal from "@/Reports/PaymentsDetailsModal.vue";
import ActionConfirmationModal from "./ActionConfirmationModal.vue";

export default {
  components: {
    ActionsMenu,
    ActionConfirmationModal,
    PaymentsDetailsModal
  },
  props: {
    record: {
      type: Object,
      default: () => ({})
    },
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showPaymentDetailsModal: false,
      voidModal: false,
      performingAction: ""
    };
  },
  computed: {
    actions() {
      return [
        {
          label: "View Details",
          icon: "far fa-square-info",
          eventName: "view-payment-details",
          className: "menu-item"
        },
        {
          label: "Dispute Charge",
          icon: "far fa-credit-card-front",
          eventName: "dispute-charge",
          className: "menu-item",
          disabled: !this.links.payment_void
        },
        {
          label: "Remove Payment",
          source: RemovePaymentIcon,
          eventName: "remove-payment",
          className: "menu-item",
          disabled: !this.links.payment_void
        }
      ];
    },
    modalContents() {
      const contents = {
        dispute: {
          message:
            "This action cannot be undone. Are you sure you want to mark this charge as disputed?\nNote: If the payment has already been batched, then you will need to manually adjust the transaction in your payment processing system.",
          title: "Dispute Charge",
          success_message: "Payment has been successfully removed.",
          event_name: "refresh-datatable",
          action_url: this.links.payment_void,
          submit_btn_class: "btn btn-danger btn-sm btn-ml",
          submit_btn_text: "Dispute",
          hide_input: true
        },
        remove: {
          message:
            "This action cannot be undone. Are you sure you want to remove this payment in Sera?\nNote: If the payment has already been batched, then you will need to manually adjust the transaction in your payment processing system.",
          title: "Remove Payment",
          success_message: "Payment has been successfully removed.",
          event_name: "refresh-datatable",
          action_url: this.links.payment_void,
          submit_btn_class: "btn btn-danger btn-sm btn-ml",
          submit_btn_text: "Remove",
          hide_input: true
        }
      };
      return contents[this.performingAction];
    }
  },
  methods: {
    toggleVoidConfirmation(action = "") {
      this.performingAction = action;
      this.voidModal = !this.voidModal;
    },
    togglePaymentsDetailsModal(status = !this.showPaymentDetailsModal) {
      this.showPaymentDetailsModal = status;
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled {
  color: #bebebe;
}
</style>
